import { createActions, createReducer } from 'reduxsauce'

import ConsultaReceitasExtraorcamentariasService from '../../servicos/ConsultaReceitasExtraorcamentariasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaReceitasExtraorcamentariasInicio: [],
    buscaConsultaReceitasExtraorcamentariasErro: ['erro'],
    buscaConsultaReceitasExtraorcamentariasSucesso: ['consultaReceitasExtraorcamentarias'],
    limpar: [],
    setConsultaReceitasExtraorcamentariasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaReceitasExtraorcamentarias = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaReceitasExtraorcamentariasInicio())
        let serv = new ConsultaReceitasExtraorcamentariasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaReceitasExtraorcamentariasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaReceitasExtraorcamentariasErro(error)))
    }
}

const buscaConsultaReceitasExtraorcamentariasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaReceitasExtraorcamentariasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaReceitasExtraorcamentariasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaReceitasExtraorcamentarias.resultado,
        dataSincronizacaoDados: action.consultaReceitasExtraorcamentarias.dataSincronizacaoDados,
        fonte: action.consultaReceitasExtraorcamentarias.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaReceitasExtraorcamentariasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS_INICIO]: buscaConsultaReceitasExtraorcamentariasInicio,
    [Types.BUSCA_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS_ERRO]: buscaConsultaReceitasExtraorcamentariasErro,
    [Types.BUSCA_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS_SUCESSO]: buscaConsultaReceitasExtraorcamentariasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_RECEITAS_EXTRAORCAMENTARIAS_ESTADO_DT]: setConsultaReceitasExtraorcamentariasEstadoDT,
})
